import { useContext } from 'react';
import { AccessibilityContext } from './AccessibilityContext';

export function useAccessibility() {
  const context = useContext(AccessibilityContext);
  if (!context) {
    throw new Error(
      'useAccessibility must be used within an AccessibilityProvider'
    );
  }
  return context;
}

export function useA11ySetting(key) {
  const { settings, setSetting } = useAccessibility();
  return [
    settings[key],
    (value) => setSetting(key, value),
  ];
}
